import { mapActions, mapGetters } from 'vuex';
import marketContractV2 from '@/components/market/v2/market-contract-v2/market-contract-v2.vue';
import moment from 'moment';
import { pushStoryInteraction, INTERACTION_TYPE } from '@/helpers/dataLayer';
import loaderMixin from '@/mixins/loader';

const MAX_CONTRACTS_TO_DISPLAY = 2;

export default {
  mixins: [
    loaderMixin
  ],
  components: {
    marketContract: marketContractV2,
  },
  props: {
    market: {
      type: Object,
      required: true,
    },
    layout: {
      type: String,
      default: 'grid',
    },
    theme: {
      type: String,
    },
    watchIcon: {
      type: Boolean,
      default: false,
    },
    trackingContext: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      hovered: false,
      showMarketImages: this.showImage && this.market.marketImageUrl,
    };
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    totalSharesTraded() {
      return Number(this.market.totalSharesTraded) || 0;
    },
    showVolume () {
      const fallbackStartDate = this.market.contracts && this.market.contracts.length > 0 ?
        this.market.contracts[0].startDate :
        null;
      const openedDate = this.market.dateOpened || fallbackStartDate;
      const daysOld = openedDate && moment(openedDate).isValid() ?
        moment().diff(moment(openedDate), 'days') :
        7;
      const isNewMarket = daysOld < 7 && this.totalSharesTraded <= 100;

      return !isNewMarket;
    },
    classModifiers() {
      return {
        'market-list-item-v2': true,
        'market-list-item-v2--large': true,
        'market-list-item-v2--hovered': this.hovered,
        'market-list-item-v2--not-logged': !this.isLoggedIn,
        [`market-list-item-v2--${this.layout}`]: true,
      };
    },
    styleModifiers() {
      return {
        '--bg-url': `url(${this.market.marketImageUrl})`,
      };
    },
    contracts() {
      const results = Array.from(this.market.contracts) || [];
      if (!results) return [];

      /* Add fake copy of a contract that represents NO contracts */
      if (results.length === 1) {
        const noContract = Object.assign({ noContract: true }, results[0]);
        results.push(noContract);
      }

      return results.slice(0, MAX_CONTRACTS_TO_DISPLAY);
    },
    showSharesOwnedNotification() {
      return this.market.userHasOwnership;
    },
    onClick() {
      this.$router.push({
        name: 'market-details',
        params: {
          marketId: this.market.marketId,
          marketUrl: this.market.marketUrl,
        },
      });
    },
  },
  methods: {
    ...mapActions('profile', ['removeMarketFromWatchList']),
    ...mapActions('browse', ['updateMarketNotWatched']),
    contractKey(contract) {
      const suffix = contract.noContract ? 'no' : 'yes';
      return `${contract.contractId}-${suffix}`;
    },
    onMouseOver() {
      this.hovered = true;
    },
    onMouseLeave() {
      this.hovered = false;
    },
    fireMarketTileClick() {
      if (!this.trackingContext.storyId) return;
      pushStoryInteraction({ interactionType: INTERACTION_TYPE.MARKET_TILE, ...this.trackingContext });
    },
    watchToggle() {
      this.loaderAddLegacy(document.body);
      this.removeMarketFromWatchList(this.market.marketId)
        .then(() => {
          this.loaderRemoveLegacy(document.body);
          this.updateMarketNotWatched(this.market.marketId);
          this.$emit('watchToggle');
        })
        .catch(() => {
          this.loaderRemoveLegacy(document.body);
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/v2/market-list-item-v2/market-list-item-v2.js